import React from "react";
import { Button, Icon, Modal } from "semantic-ui-react";
import reportStore from "stores/reportStore";

export default function PrintCollectionButton( { products, filename = "Shopkatalog.pdf", baseReport = false, template="shopkatalog" } ) {

  const [loading, setLoading] = React.useState( false )
  const [res, setResult] = React.useState( false )

  console.log('baseReport:',baseReport,products)

  return <div>
    <Modal
      size={"small"}
      onClose={() => {
        setResult( false )
      }}
      open={!!res}>
      <Modal.Header>
        <div className="flex flex-row justify-between items-center">
          <div>{translate( "Katalog" )}</div>
          <Button onClick={() => setResult( false )} basic circular icon="close"/>
        </div>
      </Modal.Header>
      <Modal.Content>
        {!res.rid && <div className={"pa3 ba bg-red white f4 tc"}>
          {translate( "Fehler bei der Erstellung Ihres PDF-Katalogs." )}
          <div className="f6">{res.error}</div>
        </div>}
        {res.rid && <div>
          <div className="pv3 tc">
            <Button as={"a"} download={`${filename}`} href={`/shop/rest/reports/load/${template}?rid=${res.rid}`}>Download</Button>
          </div>
        </div>}
      </Modal.Content>
    </Modal>

    <Button
      icon={"print"}
      onClick={async () => {
        setLoading( true )
        let result = baseReport ? (await reportStore.postBaseReport(template, products)) : (await reportStore.postReport( template , products ))
        console.log( { result } )
        setResult( result )
        setLoading( false )
      }
      }
      basic loading={loading}/>
  </div>
}



// WEBPACK FOOTER //
// ./src/components/PrintCollectionButton.js